import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { BiometricAuthentication } = await import('@containers/BiometricAuthentication/index');
    return {
        Component: BiometricAuthentication,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
